import React from 'react';

class SlidingMenu extends React.Component {
  constructor (props) {
    super(props);

    this.state = {};
  }

  render () {
    const maxHeight = this.props.isVisible ? this.props.height : 0
    return (
      <div className={'sliding-menu ' + this.props.className} style={{top: this.props.top, maxHeight}}>
        <div className='sliding-menu-container'>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default SlidingMenu;



/** WEBPACK FOOTER **
 ** ./modules/shared/sliding_menu.js
 **/